import Tooltip from '@shared/components/tooltips/workflow-tooltip';
import React from 'react';
import {
    MAX_TAG_LENGTH,
    OBM_CAMPAIGN_TEXTS,
} from '@domain/dashboard/budget-manager/modal/selector/budget-manager-selector.constants';


export const getPossibleTagOptions = (tags: Array<{label: string, value: string}>,
    campaignTag: {label?: string, value: string},
    isHovering: boolean) => {
    const selectedOption = tags.find(tag => tag.value === campaignTag?.value)
        || { label: OBM_CAMPAIGN_TEXTS.OBMPlaceHolder, value: '-' };
    return isHovering ? tags : [selectedOption];
};

export const TooltipEnabler = (child: JSX.Element,
    label: string,
    maxTagLength: number = MAX_TAG_LENGTH):
    JSX.Element => (
    (label?.length >= maxTagLength)
        ? (
            <Tooltip
                text={label}
                top={-10}
                left={-90}
                placement="right"
                verticalAlignment="top"
            >
                {child}
            </Tooltip>
        ) : child
);
